
"use strict"; // jshint ignore:line

import {
	Box3,
	EdgesGeometry,
	LineBasicMaterial,
	LineSegments,
	Mesh,
	MeshBasicMaterial,
	Object3D,
	TextGeometry,
	Vector3
} from '../../../src/js/three.module.js';

export function TextLabel( text, options ){

	Object3D.call(this);
	TextLabel.all.push( this );

	options.size   = options.size   || 0.25;
	options.height = options.height || 0;

	this.options = options;

	this.setText( text );
}

TextLabel.all = [];
TextLabel.material = new MeshBasicMaterial({ color: 0 });
TextLabel.material.depthWrite = TextLabel.material.depthTest = true; //false;

TextLabel.geometries = {};

TextLabel.prototype = Object.create( Object3D.prototype );
TextLabel.prototype.setText = function( text, size ){
	if (this.text == text || "string" != typeof (this.text = text || "")) return;

	if (!isNaN( size )) this.options.size = size;

	this.visible = !!this.text;

	var key = this.text + "" + this.options.size;

	if (TextLabel.geometries[ key ]) {
		this._text_geometry = TextLabel.geometries[ key ];
	} else {
		this._text_geometry = new TextGeometry( this.text, this.options );
		TextLabel.geometries[ key ] = this._text_geometry;
	}

	if (this._text_mesh) {
		this.remove( this._text_mesh );
		delete this._text_mesh.geometry;
	} else {
		this._text_mesh = new Mesh( this._text_geometry, TextLabel.material );
	}
	this._text_mesh.geometry = this._text_geometry;

	this.add( this._text_mesh );

	/***
	 * Testi reunaviivojen lisäämiseksi 12.5.2021 -m
	 */
	if (false) {
		this._text_mesh.renderOrder = 0;
		var geo = new EdgesGeometry( this._text_mesh.geometry );
		var mat = new LineBasicMaterial({ color: 0xffff00, linewidth: 1 });
		var wireframe = new LineSegments( geo, mat );
		wireframe.renderOrder = 1;
		this._text_mesh.add( wireframe );
	}
	/****/

	this.refresh();
}

TextLabel.prototype.refresh = (function() {

	var box  = new Box3();
	var size = new Vector3();

	return function() {

		box.setFromObject( this._text_mesh );

		box.getSize( size );
		
		var width  = Math.sqrt( size.x * size.x + size.z * size.z );
		var height = size.y;

		this._text_mesh.position.x = -width  / 2;
		this._text_mesh.position.y = -height / 2;
		this._text_mesh.position.z = 0.2;
	};
})();
